import type { ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';

interface SectionHeaderProps {
  title: string;
  description?: string;
  children?: ReactNode;
  className?: string;
  descriptionClassName?: string;
}

export function SectionHeader({
  title,
  description,
  children,
  className,
  descriptionClassName,
}: SectionHeaderProps) {
  return (
    <div className={twMerge('self-stretch flex flex-col gap-1', className)}>
      <h2 className="self-stretch justify-start text-white text-xl font-semibold leading-7">
        {title}
      </h2>
      {description ? (
        <p
          className={twMerge(
            'self-stretch justify-start text-white text-sm font-normal leading-tight',
            descriptionClassName,
          )}
        >
          {description}
        </p>
      ) : null}
      {children}
    </div>
  );
}
